import { render, staticRenderFns } from "./PortMasterNavigation.vue?vue&type=template&id=64433c71&scoped=true"
import script from "./PortMasterNavigation.vue?vue&type=script&lang=js"
export * from "./PortMasterNavigation.vue?vue&type=script&lang=js"
import style0 from "./PortMasterNavigation.vue?vue&type=style&index=0&id=64433c71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64433c71",
  null
  
)

export default component.exports